import clipMIcon from "@/assets/images/clip_m.png";
import { MessageListProps, Ticket, TicketComment } from "@/types/ticket";
import { CustomMarkdown } from "@/components/CustomMarkdown";
import {useEffect, useRef} from "react";

export default function MessageList({
  ticket,
  className,
  ticketComments,
}: MessageListProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const comments = ticket ? ticket.data_ticket_comments : ticketComments ?? [];
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({behavior: "smooth"});
  }, [comments])
  return (
    <div className={`messages ${className}`}>
      {comments?.map((item, index) => (
        <Comment
          key={`faq-ticket-message-list-${index}`}
          item={item}
          isInquiryUser={item.is_inquiry_user}
          ticket={ticket}
        />
      ))}
      <div ref={messagesEndRef}/>
    </div>
  );
}

interface CommentProps {
  item: TicketComment;
  isInquiryUser: boolean;
  ticket?: Ticket;
}

const Comment = ({ item, isInquiryUser, ticket }: CommentProps) => {
  const messageType = !isInquiryUser ? "received" : "sent";
  const group_name = item.display_created_group_by || item.created_group_by;
  const messageSentInfo = `${group_name} ${item.created_user_by}`;

  return (
    <div>
      <div className={`${messageType}-message`}>
        <div className={`${messageType}-message-name`}>{messageSentInfo}</div>
        <div className={`${messageType}-message-box`}>
          <div>
            <CustomMarkdown content={item.comment} />
          </div>
          {item.attached_files.length > 0 && (
            <>
              <hr />
              {item.attached_files.map((file, index) => (
                <div key={index} className="uk-flex uk-flex-middle">
                  <img
                    src={clipMIcon}
                    width={16}
                    height={16}
                    className="uk-margin-small-right"
                  />
                  <a href={file.filepath} target="_blank">
                    {file.original_filename}
                  </a>
                </div>
              ))}
            </>
          )}
        </div>
        <div className={`${messageType}-message-time`}>{item.created}</div>
      </div>
    </div>
  );
};